import { render, staticRenderFns } from "./RoutingStaticList.vue?vue&type=template&id=10ad7a6c&"
import script from "./RoutingStaticList.vue?vue&type=script&lang=js&"
export * from "./RoutingStaticList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports